export enum PaymentContext {
  Orphan = 'Orphan',
  Business = 'Business',
  Program = 'Program'
}
